module.exports = __webpack_public_path__ + "img/bdcjhy.d23dbc29.jpg";